import { useState } from "react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import KineticTitle from "@/components/KineticTitle";
import { BookCard, BookModal } from "@/components/BookCard";
import { site, books } from "@/data/content";

export default function Libri() {
  const [selected, setSelected] = useState(null);
  return (
    <>
      <Seo
        title={"I miei libri — " + site.name}
        description="I libri di Luisa Miceli: poesia, narrativa e riflessione sulla libertà femminile. Catalogo, stati editoriali e link Amazon quando disponibili."
      />

      <section className="pt-36 lg:pt-44 pb-16" data-testid="libri-hero">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-bordeaux">
            Catalogo editoriale
          </p>
          <KineticTitle
            lines={["I miei libri —", "parole per attraversare", "il mondo."]}
            delay={0.25}
            className="mt-6 font-medium text-[clamp(2.25rem,5.5vw,4.75rem)] leading-[1.06] tracking-tight max-w-5xl"
          />
          <Reveal delay={0.45}>
            <p className="mt-8 max-w-2xl text-base sm:text-lg font-light leading-relaxed text-ink2">
              Ogni libro è un territorio da attraversare. Nelle mie pagine convivono pensiero, poesia,
              ricerca interiore e desiderio di libertà. Scrivo per dare forma alle domande, esplorare le
              contraddizioni e immaginare possibilità nuove.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 lg:pb-32" data-testid="libri-grid">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-16 lg:max-w-4xl">
            {books.map((book, i) => (
              <Reveal key={book.slug} delay={(i % 2) * 0.08}>
                <BookCard book={book} onOpen={setSelected} />
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-16 max-w-2xl text-sm font-light leading-relaxed text-muted3">
              Ogni scheda riporta lo stato editoriale e il link di acquisto solo quando sono confermati.
            </p>
          </Reveal>
        </div>
      </section>

      <BookModal book={selected} onClose={() => setSelected(null)} />
    </>
  );
}
